import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';

import { media } from '../../helpers';

import Wrapper from '../../elements/wrapper';
import Hills from '../../../images/hills.inline.svg';

const HomeNewsletterContainer = styled.div`
    padding: 100px 0;
    background-color: #f74d33;
    position: relative;

    .title-container {
        text-align: center;
        margin-bottom: 40px;
        position: relative;
        z-index: 10;

        h3 {
            color: #fff;
            font-size: 1.9rem;
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
        }

        p {
            color: #fff;
            max-width: 600px;
            margin: 0 auto 20px;
            font-size: 1rem;
        }

        a {
            font-weight: bold;
            color: #fff;
            text-decoration: none;
            font-size: 1.2rem;
            border-bottom: 2px solid #fff;
            padding-bottom: 5px;

            &:hover {
                opacity: 0.7;
            }
        }
    }

    .form-container {
        max-width: 90vw;
        text-align: center;
        position: relative;
        z-index: 10;
        ${media.small`max-width: 550px;`}
        h4 {
            font-size: 1.4rem;
            font-weight: normal;
            color: #fff;
        }

        form {
            max-width: 450px;
            margin: 0 auto;
            .input-container {
                display: flex;

                input {
                    flex: 4;
                    height: 60px;
                    padding-left: 15px;
                    margin-right: 10px;
                    border-radius: 5px;
                    border: none;
                    color: #702716;
                    background-color: #e0e0e0;
                }

                button {
                    flex: 1.5;
                    font-weight: bold;
                    background-color: #f74c34;
                    border: 1px solid #f74c34;
                    color: #fff;
                    font-family: sans-serif;
                    border-radius: 5px;
                    border-color: #fff;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                    ${media.small`flex: 1; border-color: #f74c34;`}
                }
            }
        }
    }
    .svg-container {
        svg {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;

            g {
                mask: none;
            }
        }
    }
`;

const HomeNewsletter = () => {
    const data = useStaticQuery(graphql`
        query {
            home: allWpPage(filter: { title: { eq: "Home" } }) {
                edges {
                    node {
                        id
                        home_acf {
                            newsletterSettings {
                                newsletterCaption
                                newsletterTitle
                                newsletterButton {
                                    title
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const { newsletterButton, newsletterTitle, newsletterCaption } =
        (data && data.home.edges[0].node.home_acf.newsletterSettings) || {};

    return (
        <HomeNewsletterContainer>
            <Wrapper className="title-container">
                <h3>{newsletterTitle}</h3>
                <p>{newsletterCaption}</p>
                <div className="btn-container">
                    <Link to={newsletterButton.url}>
                        {newsletterButton.title}
                    </Link>
                </div>
            </Wrapper>
            <Wrapper className="form-container">
                <h4>Begin your Goodform journey with 10% off.</h4>
                <form>
                    <div className="input-container">
                        <input
                            type="email"
                            required
                            placeholder="your@emailhere.com"
                        />
                        <button>Sign Up</button>
                    </div>
                </form>
            </Wrapper>
            <div className="svg-container">
                <Hills />
            </div>
        </HomeNewsletterContainer>
    );
};

export default HomeNewsletter;
